export enum MODULE_SORTS {}

export enum MODULE_FILTERS {
  IS_DEFAULT = "filter[is_default]",
}
